import {
  Avatar,
  Box,
  Divider,
  Drawer,
  IconButton,
  ListItemButton,
  ListItemIcon,
  Paper,
  Menu as MenuComponent,
  Stack,
  useMediaQuery,
  MenuItem,
  Typography,
} from "@mui/material";
import { createContext, useEffect, useRef, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import "../../css/App.scss";
import "./layout.scss";
import { theme } from "../../utilities/themes";
import "../../images/svg/logo_anim/logo_anim.scss";
import logo from "../../images/png/logo.png";
import logo_old from "../../images/png/logo_old.png";
import {
  ConfirmationNumber,
  Help,
  Home,
  Login,
  Logout,
  Mail,
  Menu,
} from "@mui/icons-material";
import Footer from "../../components/footer";
import AuthDialog from "../../components/authDialog";
import SplashScreenComponent from "./components/splashScreen";
import ContactUsDialog from "../contact_us_page/components/contactUsDialog";
import { AuthContext } from "../../context/auth/authContext";
import { useContext } from "react";

const SplashContext = createContext();
const NavContext = createContext();
const Layout = () => {
  /* #region State and Ui controllers */
  const [navOpen, setNavOpen] = useState(false);
  const [signInOpen, setSignInPoppoverOpen] = useState(false);
  const [userPopoverOpen, setUserPopoverOpen] = useState(false);
  const anchorEl = useRef();
  const [contactUsOpen, setContactUsOpen] = useState(false);
  const toggleSignIn = (open) => {
    setSignInPoppoverOpen(open);
  };
  const [navBarHeight, SetNavBarHeight] = useState(65);
  const authContext = useContext(AuthContext);
  const [splashScreenActive, setSplashScreenActive] = useState(true);
  const [error, setError] = useState();
  /* #endregion */

  /* #region  styles and components */
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const NavLink = ({ children, sx, onClick = () => {}, ref, href }) => {
    return (
      <Link
        to={href}
        style={{
          height: "100%",
        }}
      >
        <Box
          component="button"
          onClick={(event) => {
            onClick(event);
            setNavOpen(false);
          }}
          ref={ref}
          className="NavLink"
          sx={{
            ...sx,
            fontFamily: "Product Sans",
            fontWeight: 200,
            textTransform: "uppercase",
            fontSize: "1rem",
            "&:hover": {
              backgroundColor: "rgb(100,100,100)",
            },
            m: 0,
            height: "100%",
            cursor: "pointer",
          }}
          color="white"
        >
          {children}
        </Box>
      </Link>
    );
  };
  const Logo = ({ children, href, sx }) => {
    return (
      <Box
        component="button"
        onClick={() => setNavOpen(false)}
        className="NavLink"
        sx={{ p: 0, pl: 1, height: "100%", ...sx, fontFamily: "Nunito" }}
      >
        <Link to={href}>{children}</Link>
      </Box>
    );
  };
  const LinkGroup = () => (
    <>
      {authContext.loggedIn ? (
        <>
          <Box
            component="button"
            onClick={(event) => {
              setUserPopoverOpen(true);
            }}
            className="NavLink"
            sx={{
              fontFamily: "Product Sans",
              fontWeight: 200,
              textTransform: "uppercase",
              fontSize: "1rem",
              "&:hover": {
                backgroundColor: "rgb(100,100,100)",
              },
              m: 0,
              height: "100%",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            color="white"
          >
            <Avatar src={authContext.userDetails.ProfilePicture}>
              {authContext.userDetails.FullName.split("")[0]}
            </Avatar>
          </Box>
          <MenuComponent
            id={"userPopover"}
            open={userPopoverOpen}
            anchorEl={anchorEl.current}
            onClose={() => setUserPopoverOpen(false)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <MenuItem sx={{ width: "15vw" }}>
              <Stack
                spacing={2}
                alignItems="center"
                justifyContent={"center"}
                width="100%"
              >
                <Avatar
                  sx={{
                    width: "10vh",
                    height: "10vh",
                  }}
                  src={authContext.userDetails.ProfilePicture}
                >
                  {authContext.userDetails.FullName.split("")[0]}
                </Avatar>
                <span>{authContext.userDetails.FullName}</span>
              </Stack>
            </MenuItem>

            <MenuItem
              onClick={() => {
                authContext.logoutFunc().then(() => setUserPopoverOpen(false));
              }}
            >
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </MenuComponent>
        </>
      ) : (
        <Box
          component="button"
          onClick={(event) => {
            toggleSignIn(true);
            setNavOpen(false);
          }}
          className="NavLink"
          sx={{
            fontFamily: "Product Sans",
            fontWeight: 200,
            textTransform: "uppercase",
            fontSize: "1rem",
            "&:hover": {
              backgroundColor: "rgb(100,100,100)",
            },
            m: 0,
            height: "100%",
            cursor: "pointer",
          }}
          color="white"
        >
          Sign in
        </Box>
      )}

      <NavLink href={"/faq"}>FAQ</NavLink>
      <Box
        component="button"
        onClick={(event) => {
          setContactUsOpen(true);
          setNavOpen(false);
        }}
        className="NavLink"
        sx={{
          fontFamily: "Product Sans",
          fontWeight: 200,
          textTransform: "uppercase",
          fontSize: "1rem",
          "&:hover": {
            backgroundColor: "rgb(100,100,100)",
          },
          m: 0,
          height: "100%",
          cursor: "pointer",
        }}
        color="white"
      >
        Contact us
      </Box>
      {/* <NavLink href="/contact-us">Contact us</NavLink> */}
      <NavLink href="/tickets">My tickets</NavLink>
      <Box
        component="button"
        onClick={(event) => {
          window.location.href = "https://apps.little.africa/events";
        }}
        className="NavLink"
        sx={{
          fontFamily: "Product Sans",
          fontWeight: 200,
          textTransform: "uppercase",
          fontSize: "1rem",
          "&:hover": {
            backgroundColor: "rgb(100,100,100)",
          },
          m: 0,
          height: "100%",
          cursor: "pointer",
        }}
        color="white"
      >
        Events
      </Box>
    </>
  );
  /* #endregion */

  /* #region  Splash screen functions */

  /**
   * A function to remove the splash screen if present.
   * @param {Promise} taskPromise The promise that will turn off the splash screen once comment has loaded.
   */
  const splashScreen = (taskPromise) => {
    let onComplete = () => {
      let spScreen = document.getElementById("splashScreen");
      spScreen && spScreen.classList.add("end");
      setTimeout(() => {
        setSplashScreenActive(false);
      }, 500);
    };
    setSplashScreenActive(true);
    if (taskPromise) {
      taskPromise()
        .then(() => {
          onComplete();
        })
        .catch((error) => {
          if (error.code === "ERR_NETWORK") {
            setError({
              message: "Network error",
              description:
                "Please check your internet connection and try again",
            });
          } else {
            setError({
              message: "Something went wrong",
              description: "Please try refreshing the page",
            });
          }
          onComplete();
        });
    } else {
      //no data to load

      onComplete();
    }
  };
  /* #endregion */

  useEffect(() => {
    SetNavBarHeight(isMobile ? 50 : 65);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  return (
    <>
      {splashScreenActive && <SplashScreenComponent />}
      {error ? (
        <Box
          sx={{
            bgcolor: "white",
            height: "100vh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Stack spacing={2} width="60%" height="80%">
            <Box component="img" src={logo_old} sx={{ width: "40%" }} />
            <Typography variant="h4">{error.message}</Typography>
            <Typography variant="body1">{error.description}</Typography>
          </Stack>
        </Box>
      ) : (
        <>
          {
            //#region Nav Bar
          }
          <Paper
            sx={{
              width: "100%",
              height: navBarHeight,
              display: "flex",
              backgroundColor: "rgb(50,50,50)",
              borderRadius: 0,
              position: "fixed",
              zIndex: 2,
            }}
            ref={anchorEl}
            elevation={2}
          >
            <Stack direction="row" sx={{ width: "100%" }}>
              <Box sx={{ height: "100%", flexGrow: 3 }}>
                <Logo
                  sx={{
                    whiteSpace: "nowrap",
                    width: "fit-content",
                    "&:hover": {
                      backgroundColor: "rgb(100,100,100)",
                    },
                    pr: "1vw",
                  }}
                  href="/"
                >
                  <img
                    style={{
                      height: isMobile
                        ? `calc(${navBarHeight}px - 25px)`
                        : `calc(${navBarHeight}px - 30px)`,
                      width: "auto",
                    }}
                    alt="logo"
                    src={logo}
                    className="objFit"
                  />
                </Logo>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexGrow: 7,
                  flexDirection: "row-reverse",
                  alignItems: "center",
                }}
              >
                {!isMobile ? (
                  <>
                    <LinkGroup />
                  </>
                ) : (
                  <IconButton
                    sx={{ marginRight: "2vw" }}
                    onClick={() => setNavOpen((open) => !open)}
                  >
                    <Menu sx={{ color: "white" }} />
                  </IconButton>
                )}
              </Box>
            </Stack>
            {
              //#region Mobile Nav
            }
            <Drawer
              open={navOpen}
              onClose={() => setNavOpen(false)}
              anchor="right"
            >
              <Stack width={"60vw"}>
                <Box
                  component="button"
                  onClick={() => setNavOpen(false)}
                  className="NavLink"
                  sx={{
                    p: 0,
                    pl: 1,
                    fontFamily: "Nunito",
                    mb: "2vh",
                    mt: "3vh",
                  }}
                >
                  <Link to="/">
                    <img
                      style={{
                        width: "80%",
                        height: "auto",
                      }}
                      className="objFit"
                      alt="logo"
                      src={logo_old}
                    />
                  </Link>
                </Box>
                <Link
                  to="/"
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                  onClick={() => setNavOpen(false)}
                >
                  <ListItemButton>
                    <ListItemIcon>
                      <Home />
                    </ListItemIcon>
                    Home
                  </ListItemButton>
                </Link>
                <Divider />
                <Link
                  to="/tickets"
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                  onClick={() => setNavOpen(false)}
                >
                  <ListItemButton>
                    <ListItemIcon>
                      <ConfirmationNumber />
                    </ListItemIcon>
                    My Tickets
                  </ListItemButton>
                </Link>
                <Divider />
                <ListItemButton
                  onClick={(event) => {
                    setContactUsOpen(true);
                    setNavOpen(false);
                  }}
                >
                  <ListItemIcon>
                    <Mail />
                  </ListItemIcon>
                  Contact Us
                </ListItemButton>
                <Divider />
                <Link
                  to="/faq"
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                  onClick={() => setNavOpen(false)}
                >
                  <ListItemButton>
                    <ListItemIcon>
                      <Help />
                    </ListItemIcon>
                    FAQ
                  </ListItemButton>
                </Link>
                <Divider />
                <ListItemButton
                  onClick={(event) => {
                    if (!authContext.loggedIn) {
                      toggleSignIn(true);
                      setNavOpen(false);
                    } else {
                      authContext.logoutFunc();
                      setNavOpen(false);
                    }
                  }}
                >
                  <ListItemIcon>
                    {authContext.loggedIn ? <Logout /> : <Login />}
                  </ListItemIcon>
                  {authContext.loggedIn ? <>Log out</> : <>Sign in</>}
                </ListItemButton>
              </Stack>
            </Drawer>
            {
              //#endregion
            }
          </Paper>
          {
            //#endregion
          }
          {
            //#region page content
          }
          <Box
            sx={{
              minHeight: "100vh",
              width: "100%",
            }}
          >
            <Stack>
              <Box sx={{ height: navBarHeight }}></Box>
              <SplashContext.Provider value={splashScreen}>
                <NavContext.Provider value={navBarHeight}>
                  <Outlet />
                </NavContext.Provider>
              </SplashContext.Provider>
            </Stack>
          </Box>
          {
            //#endregion
          }
          <AuthDialog
            open={signInOpen}
            setOpen={toggleSignIn}
            onLogin={() => {}}
            title="Sign in"
          />
          <ContactUsDialog open={contactUsOpen} setOpen={setContactUsOpen} />
          <Footer />
        </>
      )}
    </>
  );
};
export default Layout;
export { SplashContext, NavContext };
